export default {
  setTenderSuppliersInfo(state, payload) {
    state.tenderSuppliersInfo = payload
  },
  setSuppliersShortStatistic(state, payload) {
    state.suppliersShortStatistic = payload || {}
  },
  setCrmVerificationFillingInfo(state, payload) {
    state.crmVerificationFillingInfo = payload
  },
}
